import { Component, Input, OnInit } from '@angular/core';
import { PublikationListEntry } from '../../../../core/gb-api';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-publikation-list-detail',
  templateUrl: './publikation-list-detail.component.html',
  styleUrls: ['./publikation-list-detail.component.scss'],
  imports: [TranslatePipe]
})
export class PublikationListDetailComponent implements OnInit {
  @Input() publikation: PublikationListEntry;

  constructor() {}

  ngOnInit() {}
}
